import {ActivatedRoute, Router} from '@angular/router';
import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {take} from 'rxjs/operators';

import {AuthService} from '@services/auth.service';

@Component({
  selector: 'app-adfs-callback',
  templateUrl: './adfs-callback.component.html',
  styleUrls: ['./adfs-callback.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ADFSCallbackComponent implements OnInit {
  code: string;
  state: string;
  error: string;

  constructor(private route: ActivatedRoute, protected router: Router, protected authService: AuthService) { }

  ngOnInit() {
    this.route.queryParams.pipe(take(1)).subscribe(params => {
      this.code = params['code'];
      this.state = params['state'];

      this.authService.login(undefined, undefined, this.code, this.state).pipe(take(1)).subscribe(
        result => {
          this.router.navigateByUrl(
            result.redirect || '/family-room-directory',
            {replaceUrl: true},
          );
        }
      );
    });
  }
}
